import { users } from 'types';
import React from 'react';
import {
    EEkycStatuesesApi,
    EEkycStatuses,
    EUserStatus,
} from 'types/entities/users';

import {
    TMaterialTableColumns,
    TMaterialTableColumnsRenderFC,
} from 'components/table/index.types';
import LockIcon from '@material-ui/icons/Lock';
import { Center } from 'components/layout/layout';
import { CellEkycStatus, CellEkycStatusProcessing, CellRiskProfile } from './user-list.styled';

const fullName = (user: users.TUsers) => {
    if (user.ekycDetails && user.ekycDetails.name) {
        return `${user.ekycDetails.name}`;
    }
    if (user.firstName === user.lastName) {
        return `${user.firstName}`;
    }
    if (user.lastName === null) {
        return `${user.firstName}`;
    }
    return `${user.firstName} ${user.lastName}`;
};

/** TODO: Pass handlers only */
const usersColumns = ({
    ControlButtonsComponent,
    VerifyProfileComponent,
}: {
    ControlButtonsComponent: TMaterialTableColumnsRenderFC<users.TUsers>;
    VerifyProfileComponent: TMaterialTableColumnsRenderFC<users.TUsers>;
}): TMaterialTableColumns<users.TUsers> => [
    {
        width: '50',
        key: 'phoneNumber',
        title: 'Phone number',
    },
    {
        title: 'Full Name',
        width: '100',
        render: ({ rowData }) => (
            <Center vertOnly>
                {fullName(rowData)}
            </Center>
        )
    },
    {
        width: '50',
        key: 'nexId',
        title: 'NEX ID',
    },
    {
        title: 'Is blocked',
        width: '50',
        render: ({ rowData }) => (
            <Center vertOnly>
                {rowData.loginBlockedAt ? <LockIcon /> : '-'}
            </Center>
        ),
    },
    {
        title: 'Is suspended',
        width: '50',
        render: ({ rowData }) => (
            <Center vertOnly>
                {rowData.status === EUserStatus.SUSPENDED ? <LockIcon /> : '-'}
            </Center>
        ),
    },
    {
        title: 'eKYC status',
        width: '100',
        render: (props) => {
            switch (props.rowData.ekycStatus) {
                case EEkycStatuesesApi.EKYC_STATUS_PROCESSING:
                    return (
                        <CellEkycStatusProcessing>
                            <CellEkycStatus status={EEkycStatuses.PROCESSING}>
                                {EEkycStatuses.PROCESSING}
                            </CellEkycStatus>
                        </CellEkycStatusProcessing>
                    );
                case EEkycStatuesesApi.EKYC_STATUS_VERIFIED:
                    return (
                        <CellEkycStatus status={EEkycStatuses.VERIFIED}>
                            {EEkycStatuses.VERIFIED}
                        </CellEkycStatus>
                    );
                case EEkycStatuesesApi.EKYC_STATUS_REJECTED:
                    return (
                        <CellEkycStatus status={EEkycStatuses.REJECTED}>
                            {EEkycStatuses.REJECTED}
                        </CellEkycStatus>
                    );
                default:
                    return (
                        <CellEkycStatus status={EEkycStatuses.UNVERIFIED}>
                            {EEkycStatuses.UNVERIFIED}
                        </CellEkycStatus>
                    );
            }
        },
    },
    {
        width: '50',
        key: 'nexCashBalance',
        title: 'NEX Cash Balance',
        render: (props) => {
            return (
                <span>
                    Rp{' '}
                    {props.rowData.nexCashBalance
                        ? props.rowData.nexCashBalance.toLocaleString('en-US')
                        : 0}
                </span>
            );
        },
    },
    {
        width: '50',
        key: 'status',
        title: 'Status',
    },
    {
        width: '50',
        title: 'Risk Profile',
        render: (props) => {
            if (!props.rowData.latestRiskProfile) {
                return (
                  <CellRiskProfile>
                      Have No Risk Profile
                  </CellRiskProfile>
                )
            }
            // Lite Users should not have risk profile
            if (props.rowData.ekycStatus === EEkycStatuesesApi.EKYC_STATUS_UNVERIFIED) {
                return (
                  <CellRiskProfile>-</CellRiskProfile>
                )
            }
            return (
              <>
                  Score: &nbsp;
                  <CellRiskProfile score={props.rowData.latestRiskProfile.riskScore}>
                      {props.rowData.latestRiskProfile.riskScore}
                  </CellRiskProfile>
              </>
            )
        },
    }
];

export default usersColumns;
